import {ChangeDetectionStrategy, Component} from '@angular/core';
import {AuthService} from "../../_services/auth.service";
import {ContentService} from "../../_services/content.service";
import {MatDialog} from "@angular/material/dialog";
import {User} from "../../_types/user";
import {WrittenGuide} from "../../_types/content";

@Component({
    selector: 'app-written-guides',
    templateUrl: './written-guides.component.html',
    styleUrl: './written-guides.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WrittenGuidesComponent {
    user!: User;
    trainingCentre: WrittenGuide[] = []
    loading: boolean = true;
    loadFailed: boolean = false;

    constructor(private authService: AuthService,
                private contentService: ContentService,
                public dialog: MatDialog) {
        this.authService.getUser().subscribe({
            next: r => {
                this.user = r;
            }
        })
        this.authService.refreshUser();
        this.authService.getDynamicSettings().then((r): void => {
            this.contentService.writtenGuides({
                training_center_type: this.user?.role?.role_type,
                role: this.user?.role?.name,
                is_raa_training: r.is_raa
            }).subscribe({
                next: r => {
                    this.loading = false;
                    this.trainingCentre = r;
                }, error: error => {
                    this.loadFailed = true;
                    this.loading = false;
                    console.error(error)
                }
            });
        });
    }

    link(url: string, download: boolean, name?: string): void {
        this.authService.refreshUser();
        if (download) {
            let downloadName: string | undefined = url
            if (name) {
                downloadName = name?.replace(/ /g, "_");
            }
            fetch(url)
                // check to make sure you didn't have an unexpected failure (may need to check other things here depending on use case / backend)
                .then(resp => resp.status === 200 ? resp.blob() : Promise.reject('something went wrong'))
                .then(blob => {
                    const url: string = window.URL.createObjectURL(blob);
                    const a: HTMLAnchorElement = document.createElement('a');
                    a.style.display = 'none';
                    a.href = url;
                    // the filename you want
                    if (typeof downloadName === "string") {
                        a.download = downloadName;
                    }
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch((): void => {
                    console.error('catch error')
                    window.open(url, '_blank')?.focus();
                });
        } else {
            window.open(url, '_blank')?.focus();
        }
    }

}
